import {
  BookOpen,
  ChartColumn,
  Handshake,
  HardHat,
  Images,
  LayoutDashboard,
  LucideIcon,
  Receipt,
  Settings,
  Users,
} from "lucide-react";
import { Link } from "@/lib/nav";
import { usePathname } from "@/lib/nav";

import { cn } from "@/lib/utils";
import { APP_NAV, findNavMatch } from "@/shell/nav";

const NAV_ICONS: Record<string, LucideIcon> = {
  "/app": LayoutDashboard,
  "/app/customers": Users,
  "/app/quotes": Receipt,
  "/app/contracts": Handshake,
  "/app/portfolio": Images,
  "/app/insights": ChartColumn,
  "/app/projects": HardHat,
  "/app/standards": BookOpen,
  "/app/settings": Settings,
};

export interface NavBadge {
  count: number;
  /** 눈에 띄어야 하는 수(미확인)인지, 그냥 규모(총 건수)인지. */
  alert?: boolean;
}

interface Props {
  badges?: Record<string, NavBadge>;
  /** 모바일 드로어에서 항목을 누르면 닫히도록. */
  onNavigate?: () => void;
}

const AppNavList = ({ badges, onNavigate }: Props) => {
  const activeHref = findNavMatch(usePathname())?.item.href;

  return (
    <nav className="flex flex-col gap-y-1">
      {APP_NAV.map((group) => (
        <div key={group.label} className="flex flex-col">
          <span className="px-3 pb-1 pt-4 text-xs font-medium uppercase tracking-[0.16em] text-rail-muted">
            {group.label}
          </span>

          {group.items.map((item) => {
            const Icon = NAV_ICONS[item.href];
            const badge = badges?.[item.href];
            const isActive = item.href === activeHref;

            return (
              <Link
                key={item.href}
                className={cn(
                  "flex items-center gap-x-2.5 rounded-md px-3 py-2 text-sm",
                  isActive ? "bg-primary font-medium text-primary-foreground" : "text-rail-foreground hover:bg-rail-active hover:text-rail-strong"
                )}
                href={item.href}
                onClick={onNavigate}>
                {Icon && <Icon className={cn("size-4 shrink-0", !isActive && "opacity-80")} />}
                {item.name}

                {badge && badge.count > 0 && (
                  <span
                    className={cn(
                      "ml-auto rounded-full px-1.5 text-xs leading-5 tabular-nums",
                      badge.alert
                        ? "bg-destructive text-destructive-foreground"
                        : isActive
                          ? "bg-primary-foreground text-primary"
                          : "bg-rail-active text-rail-muted"
                    )}>
                    {badge.count}
                  </span>
                )}
              </Link>
            );
          })}
        </div>
      ))}
    </nav>
  );
};

export default AppNavList;
